import { Container, Row, Col, InputGroup, Form, Button } from "react-bootstrap";
import { ChevronRight, Search } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import TenderHeader from "../components/TenderHeader";
import { TENDERS, TIMELINE_ITEMS, bidders } from "../constants";
import { useState } from "react";
import { Table } from "react-bootstrap";
import "../styles/TenderDetails.css";
const TenderBiddersPage = () => {
  const { id } = useParams();
  const tender = TENDERS.find(t => t.id === id);

  const [searchValue, setSearchValue] = useState("");
  const [techStatus, setTechStatus] = useState("All");
  const [finStatus, setFinStatus] = useState("All");

  if (!tender) return <div className="p-4">No tender data</div>;

  return (
    <>
      <nav
  aria-label="breadcrumb"
  className="border-bottom"
  style={{
    "--bs-breadcrumb-divider": "''",
    borderColor: "rgba(229, 231, 235, 1)"
  }}
>
  <ol className="breadcrumb d-flex align-items-center py-2">

    {/* HOME */}
    <li className="breadcrumb-item d-flex align-items-center">
     <Link to="/" className="text-decoration-none">Home</Link>
      <ChevronRight size={18} className="mx-1 text-secondary" />
    </li>

    {/* RESULTS */}
    <li className="breadcrumb-item d-flex align-items-center">
     <Link to="/results" className="text-decoration-none">
  Results
</Link>
      <ChevronRight size={18} className="mx-1 text-secondary" />
    </li>

    {/* CURRENT PAGE TITLE */}
    <li className="breadcrumb-item active fw-semibold">
      {tender.title}
    </li>

  </ol>
</nav>
    <Container fluid className="py-4">
      {/* HEADER */}
      <TenderHeader tender={tender} timelineItems={TIMELINE_ITEMS} enableResultColors={true} />

      {/* BIDDERS CARD */}
      <div className="details-card mt-4">
        
        {/* TOP BAR */}
        <Row className="align-items-center mb-3">
          <Col lg={3} md={4}>
            <h6 className="section-title mb-1">All Bidders</h6>
            <span className="text-muted small">
              Showing {bidders.length} results
            </span>
          </Col>

          {/* SEARCH – EXACT AS PROVIDED */}
          <Col lg={6} md={8}>
            <InputGroup
              style={{
                border: "1.32px solid rgba(209, 213, 219, 1)",
                borderRadius: "38.24px",
                overflow: "hidden"
              }}
            >
              <InputGroup.Text
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  paddingRight: "8px"
                }}
              >
                <Search size={18} color="#6c757d" />
              </InputGroup.Text>

              <Form.Control
                placeholder="Search using keywords"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                style={{
                  border: "none",
                  boxShadow: "none"
                }}
              />

              <Button
                style={{
                  border: "none",
                  borderRadius: "38.24px",
                  height: "50px",
                  backgroundColor: "rgba(51, 124, 138, 1)",
                  padding: "0.375rem 1rem"
                }}
              >
                <Search size={18} />
              </Button>
            </InputGroup>
          </Col>

          {/* SHOW DROPDOWN */}
          <Col lg={3} className="text-end d-none d-lg-block">
            <span className="small me-2">Show</span>
            <Form.Select size="sm" style={{ width: "80px", display: "inline",borderRadius:'27px',height:'40px' }}>
              <option>20</option>
              <option>50</option>
              <option>100</option>
            </Form.Select>
          </Col>
        </Row>

        {/* FILTERS */}
        <Row className="mb-3">
          <Col lg={2} md={4}>
          <span className="small">Technical Status</span>
            <Form.Select
              size="sm"
              value={techStatus}
              onChange={(e) => setTechStatus(e.target.value)}
               style={{ width: "168px", display: "inline",borderRadius:'27px',height:'40px'}}
            >
              <option>All</option>
              <option>Qualified</option>
              <option>Disqualified</option>
            </Form.Select>
          </Col>

          <Col lg={2} md={4}>
          <span className="small">Financial Status</span>
            <Form.Select
              size="sm"
              value={finStatus}
              onChange={(e) => setFinStatus(e.target.value)}
                style={{ width: "168px", display: "inline",borderRadius:'27px',height:'40px'}}
            >
              <option>All</option>
              <option>Opened</option>
              <option>Rejected</option>
            </Form.Select>
          </Col>
        </Row>

       
       {/* TABLE */}
<div className="table-responsive mt-3">
  <Table hover className="align-middle bidders-table">
    <thead>
      <tr>
        <th>No.</th>
        <th>Rank</th>
        <th>Bidder Name</th>
        <th>Technical Status</th>
        <th>Financial Status</th>
        <th>Bid Amount</th>
        <th>Remarks</th>
      </tr>
    </thead>

    <tbody>
      {bidders.map((b, i) => {
        const techStatus = b.techStatus || "-";
        const finStatus = b.finStatus || "-";

        return (
          <tr key={i}>
            <td>{i + 1}</td>
            <td>{b.rank}</td>
            <td className="fw-semibold">{b.name}</td>

            <td>
              <span className={`status ${techStatus.toLowerCase()}`}>
                {techStatus}
              </span>
            </td>

            <td>
              <span className={`status ${finStatus.toLowerCase()}`}>
                {finStatus}
              </span>
            </td>

            <td>{b.amount}</td>
            <td>{b.remarks}</td>
          </tr>
        );
      })}
    </tbody>
  </Table>
</div>

      </div>
    </Container>
    </>
  );
};

export default TenderBiddersPage;
